import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useBusinessCard } from 'components/BusinessCard/context'
import { getUsers } from 'selectors/Account'
import { Section, InterpunctJoin } from 'components/BusinessCard/components/StyledComponents'
import { H6, P } from '@PipelineDeals/shared-react-components'

const DealOwner = () => {
  const { t } = useTranslation()
  const {
    cardMeta: {
      showOnlyFields,
      showEmptyFields
    },
    resource: deal
  } = useBusinessCard()

  const allUsers = useSelector(getUsers)

  const userOwner = useMemo(() => {
    if (showOnlyFields.includes('user') || showOnlyFields.includes('owner')) { return `${deal.user.first_name} ${deal.user.last_name}` }
    if (showOnlyFields.includes('user_id')) { return allUsers.find(user => user.id === deal.user_id)?.full_name }
  }, [deal, showOnlyFields])

  const teamOwner = useMemo(() => {
    if (!showOnlyFields.includes('team_id')) { return null }
    return deal.team?.name
  }, [deal, showOnlyFields])

  const showOwner = useMemo(() => showOnlyFields.includes('user') || showOnlyFields.includes('owner') || showOnlyFields.includes('team_id') || showOnlyFields.includes('user_id'), [showOnlyFields])

  if (!showOwner) return null
  if (!showEmptyFields && (!deal.user && !deal.owner && !deal.team_id && !deal.user_id)) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.owner')}</H6>
      <P>
        <InterpunctJoin items={[userOwner, teamOwner].filter(Boolean)} />
      </P>
    </Section>
  )
}

export default DealOwner
